module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/wasm-module.1ce0d01c05631ced18f2.js");
};